<!-- Breadcrumb Section Start -->
<section class="breadcrumb-section pt-0">
    <div class="container-fluid-lg">
        <div class="row">
            <div class="col-12">
                <div class="breadcrumb-contain">
                    <!-- <h2>About Us</h2> -->
                    <li class="breadcrumb-item">
                        <a [routerLink]="['/']" routerLinkActive="router-link-active">
                            <i class="fa-solid fa-house"></i>
                        </a>
                    </li>
                    <li class="breadcrumb-item active">About Us</li>

                    <nav>
                        <!-- <br/> -->
                        <ol class="breadcrumb mb-0">
                            <img src="assets/images/logo/logo.png" [routerLink]="['/']" routerLinkActive="router-link-active" class="logosize" alt>
                        </ol>
                    </nav>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Breadcrumb Section End -->

<!-- Fresh Vegetable Section Start -->
<section class="fresh-vegetable-section section-lg-space">
    <div class="container-fluid-lg">
        <div class="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
            <div class="col-xl-6 col-12">
                <div class="row g-sm-4 g-2">
                    <div class="col-12">
                        <div class="fresh-image-2">
                            <div>
                                <img src="assets/images/aboutUs/sriveryabout.png" class="bg-img blur-up lazyload" alt>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="col-6">
                        <div class="fresh-image">
                            <div>
                                <img src="assets/images/inner-page/about-us/2.jpg" class="bg-img blur-up lazyload" alt>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>

            <div class="col-xl-6 col-12">
                <div class="fresh-contain p-center-left">
                    <div>
                        <div class="review-title">
                            <!-- <h4>About Us</h4> -->
                            <h2>Welcome to Poushtik Spices & Foods Ltd.</h2>
                        </div>

                        <div class="delivery-list">
                            <p class="text-content">All of us have fond memories of our childhood and especially the food that was made in our kitchens. Fresh, wholesome, and tasty, we can still smell the fragrance of hot roti’s made from fresh Atta ground in neighborhood atta
                                chakkis or the curries made from authentic spices and masalas which gave it a unique color and flavor.

                            </p>
                            <p class="text-content">The story behind Poushtik Foods began in one such kitchen and is a testimony of one man’s endeavour to bring fresh, pure and the most authentic and wholesome atta, spices, and masalas back onto our dining tables.

                            </p>
                            <p class="text-content">Narayan Das Rathi is a serial entrepreneur and a visionary who dreamt of taking spices, foods, and more recently sharbati and regular atta to the discerning Indian consumer. With a single-minded focus on QUALITY, and on providing
                                the purest most authentic ingredients to our kitchens, our story is just beginning!

                            </p>

                            <!-- <ul class="delivery-box">
                                <li>
                                    <div class="delivery-box">
                                        <div class="delivery-icon">
                                            <img src="assets/svg/3/delivery.svg" class="blur-up lazyload" alt>
                                        </div>

                                        <div class="delivery-detail">
                                            <h5 class="text">Free delivery for all orders</h5>
                                        </div>
                                    </div>
                                </li>

                                <li>
                                    <div class="delivery-box">
                                        <div class="delivery-icon">
                                            <img src="assets/svg/3/leaf.svg" class="blur-up lazyload" alt>
                                        </div>

                                        <div class="delivery-detail">
                                            <h5 class="text">Only fresh foods</h5>
                                        </div>
                                    </div>
                                </li>

                                <li>
                                    <div class="delivery-box">
                                        <div class="delivery-icon">
                                            <img src="assets/svg/3/delivery.svg" class="blur-up lazyload" alt>
                                        </div>

                                        <div class="delivery-detail">
                                            <h5 class="text">Free delivery for all orders</h5>
                                        </div>
                                    </div>
                                </li>

                                <li>
                                    <div class="delivery-box">
                                        <div class="delivery-icon">
                                            <img src="assets/svg/3/leaf.svg" class="blur-up lazyload" alt>
                                        </div>

                                        <div class="delivery-detail">
                                            <h5 class="text">Only fresh foods</h5>
                                        </div>
                                    </div>
                                </li>
                            </ul> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Fresh Vegetable Section End -->

<!-- Client Section Start -->
<!-- <section class="client-section section-lg-space">
  <div class="container-fluid-lg">
    <div class="row">
      <div class="col-12">
        <div class="about-us-title text-center">
          <h4>What We Do</h4>
          <h2 class="center">We are Trusted by Clients</h2>
        </div>

        <div class="slider-3_1 product-wrapper">
          <div class="xyz">
            <div class="clint-contain">
              <div class="client-icon">
                <img src="assets/svg/3/work.svg" class="blur-up lazyload" alt>
              </div>
              <h2>10</h2>
              <h4>Business Years</h4>
              <p>A coffee shop is a small business that sells coffee, pastries,
                and other morning goods. There are many different types of
                coffee shops around the world.</p>
            </div>
          </div>

          <div class="xyz">
            <div class="clint-contain">
              <div class="client-icon">
                <img src="assets/svg/3/buy.svg" class="blur-up lazyload" alt>
              </div>
              <h2>80 K+</h2>
              <h4>Products Sales</h4>
              <p>Some coffee shops have a seating area, while some just have a
                spot to order and then go somewhere else to sit down. The coffee
                shop that I am going to.</p>
            </div>
          </div>

          <div class="xyz">
            <div class="clint-contain">
              <div class="client-icon">
                <img src="assets/svg/3/user.svg" class="blur-up lazyload" alt>
              </div>
              <h2>90%</h2>
              <h4>Happy Customers</h4>
              <p>My goal for this coffee shop is to be able to get a coffee and
                get on with my day. It's a Thursday morning and I am rushing
                between meetings.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section> -->
<!-- Client Section End -->

<!-- Team Section Start -->
<!-- <section class="team-section section-lg-space">
    <div class="container-fluid-lg">
        <div class="about-us-title text-center">
            <h4 class="text-content">Our Creative Team</h4>
            <h2 class="center">fastkart team member</h2>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="slider-user product-wrapper">
                    <div>
                        <div class="team-box">
                            <div class="team-image">
                                <img src="assets/images/inner-page/user/1.jpg" class="img-fluid blur-up lazyload" alt>
                            </div>

                            <div class="team-name">
                                <h3>Anna Baranov</h3>
                                <h5>Marketing</h5>
                                <p>cheeseburger airedale mozzarella the big cheese fondue.</p>
                                <ul class="team-media">
                                    <li>
                                        <a href="https://www.facebook.com/" class="fb-bg">
                                            <i class="fa-brands fa-facebook-f"></i>
                                        </a>
                                    </li>

                                    <li>
                                        <a href="https://in.pinterest.com/" class="pint-bg">
                                            <i class="fa-brands fa-pinterest-p"></i>
                                        </a>
                                    </li>

                                    <li>
                                        <a href="https://twitter.com/" class="twitter-bg">
                                            <i class="fa-brands fa-twitter"></i>
                                        </a>
                                    </li>

                                    <li>
                                        <a href="https://www.instagram.com/" class="insta-bg">
                                            <i class="fa-brands fa-instagram"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div class="team-box">
                            <div class="team-image">
                                <img src="assets/images/inner-page/user/2.jpg" class="img-fluid blur-up lazyload" alt>
                            </div>

                            <div class="team-name">
                                <h3>Anna Baranov</h3>
                                <h5>Marketing</h5>
                                <p>cheese on toast mozzarella bavarian bergkase smelly cheese cheesy feet.</p>
                                <ul class="team-media">
                                    <li>
                                        <a href="https://www.facebook.com/" class="fb-bg">
                                            <i class="fa-brands fa-facebook-f"></i>
                                        </a>
                                    </li>

                                    <li>
                                        <a href="https://in.pinterest.com/" class="pint-bg">
                                            <i class="fa-brands fa-pinterest-p"></i>
                                        </a>
                                    </li>

                                    <li>
                                        <a href="https://twitter.com/" class="twitter-bg">
                                            <i class="fa-brands fa-twitter"></i>
                                        </a>
                                    </li>

                                    <li>
                                        <a href="https://www.instagram.com/" class="insta-bg">
                                            <i class="fa-brands fa-instagram"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div class="team-box">
                            <div class="team-image">
                                <img src="assets/images/inner-page/user/3.jpg" class="img-fluid blur-up lazyload" alt>
                            </div>

                            <div class="team-name">
                                <h3>Anna Baranov</h3>
                                <h5>Marketing</h5>
                                <p>camembert de normandie. Bocconcini rubber cheese fromage frais port-salut.</p>
                                <ul class="team-media">
                                    <li>
                                        <a href="https://www.facebook.com/" class="fb-bg">
                                            <i class="fa-brands fa-facebook-f"></i>
                                        </a>
                                    </li>

                                    <li>
                                        <a href="https://in.pinterest.com/" class="pint-bg">
                                            <i class="fa-brands fa-pinterest-p"></i>
                                        </a>
                                    </li>

                                    <li>
                                        <a href="https://twitter.com/" class="twitter-bg">
                                            <i class="fa-brands fa-twitter"></i>
                                        </a>
                                    </li>

                                    <li>
                                        <a href="https://www.instagram.com/" class="insta-bg">
                                            <i class="fa-brands fa-instagram"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div class="team-box">
                            <div class="team-image">
                                <img src="assets/images/inner-page/user/4.jpg" class="img-fluid blur-up lazyload" alt>
                            </div>

                            <div class="team-name">
                                <h3>Anna Baranov</h3>
                                <h5>Marketing</h5>
                                <p>Fondue stinking bishop goat. Macaroni cheese croque monsieur cottage cheese.</p>
                                <ul class="team-media">
                                    <li>
                                        <a href="https://www.facebook.com/" class="fb-bg">
                                            <i class="fa-brands fa-facebook-f"></i>
                                        </a>
                                    </li>

                                    <li>
                                        <a href="https://in.pinterest.com/" class="pint-bg">
                                            <i class="fa-brands fa-pinterest-p"></i>
                                        </a>
                                    </li>

                                    <li>
                                        <a href="https://twitter.com/" class="twitter-bg">
                                            <i class="fa-brands fa-twitter"></i>
                                        </a>
                                    </li>

                                    <li>
                                        <a href="https://www.instagram.com/" class="insta-bg">
                                            <i class="fa-brands fa-instagram"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div class="team-box">
                            <div class="team-image">
                                <img src="assets/images/inner-page/user/1.jpg" class="img-fluid blur-up lazyload" alt>
                            </div>

                            <div class="team-name">
                                <h3>Anna Baranov</h3>
                                <h5>Marketing</h5>
                                <p>squirty cheese cheddar macaroni cheese airedale cheese triangles.
                                </p>
                                <ul class="team-media">
                                    <li>
                                        <a href="https://www.facebook.com/" class="fb-bg">
                                            <i class="fa-brands fa-facebook-f"></i>
                                        </a>
                                    </li>

                                    <li>
                                        <a href="https://in.pinterest.com/" class="pint-bg">
                                            <i class="fa-brands fa-pinterest-p"></i>
                                        </a>
                                    </li>

                                    <li>
                                        <a href="https://twitter.com/" class="twitter-bg">
                                            <i class="fa-brands fa-twitter"></i>
                                        </a>
                                    </li>

                                    <li>
                                        <a href="https://www.instagram.com/" class="insta-bg">
                                            <i class="fa-brands fa-instagram"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->
<!-- Team Section End -->
